// Repli quand Google Maps refuse la clé (17/10/2026, Meeting Point bloqué).
//
// Quand la clé est refusée (ApiNotActivatedMapError, clé invalide…), Google
// DÉSACTIVE chaque champ relié à son autocomplétion (code postal, adresse) et y
// écrit « Petit problème… Une erreur s'est produite ». Le client ne peut plus
// rien taper : les envois vers les pays « express » (Allemagne, France,
// Pays-Bas…) restent bloqués à la première étape, faute de codes postaux.
//
// Ici on rend la main au clavier : le champ redevient saisissable, garde son
// texte d'aide d'origine, et Google n'y est plus rebranché.

const CLASSE_ERREUR = 'gm-err-autocomplete'

// Rend un champ désactivé par Google de nouveau saisissable.
export function rendreLaMain(champ, aideOrigine, maps) {
  if (!champ || !champ.classList || !champ.classList.contains(CLASSE_ERREUR)) return false
  if (maps && maps.event && maps.event.clearInstanceListeners) {
    maps.event.clearInstanceListeners(champ)
  }
  champ.classList.remove(CLASSE_ERREUR)
  champ.disabled = false
  if (aideOrigine !== undefined) champ.placeholder = aideOrigine
  if (champ.style) champ.style.backgroundImage = 'none'
  return true
}

// Une fois Google en panne, les écrans qui rebranchent l'autocomplétion
// (changement de pays, nouvelle étape) reçoivent une version inerte.
export function neutraliserAutocomplete(maps) {
  if (!maps || !maps.places || maps.places.__ekRepli) return
  maps.places.Autocomplete = function AutocompleteInerte() {
    return {
      addListener() { return { remove() {} } },
      getPlace() { return {} },
      setComponentRestrictions() {},
      setOptions() {},
      setFields() {},
      setTypes() {},
      bindTo() {},
    }
  }
  maps.places.__ekRepli = true
}

export function installerRepliGoogleMaps(win = window, doc = document) {
  const aides = new WeakMap()
  const maps = () => (win.google && win.google.maps) || null

  const reparer = (champ) => {
    // Le curseur n'est rendu qu'au champ qui l'avait encore (relecture du 17/10 :
    // jamais à un champ quitté entre-temps, sinon le clavier s'ouvre sur mobile).
    const avaitLaMain = doc.activeElement === champ
    if (!rendreLaMain(champ, aides.get(champ), maps())) return
    neutraliserAutocomplete(maps())
    if (avaitLaMain && champ.focus) champ.focus()
  }

  new win.MutationObserver((mutations) => {
    // 1er passage : garder le texte d'aide d'origine, que Google remplace.
    for (const m of mutations) {
      const parGoogle = m.target.classList && m.target.classList.contains(CLASSE_ERREUR)
      if (m.attributeName === 'placeholder' && parGoogle && !aides.has(m.target)) aides.set(m.target, m.oldValue || '')
    }
    // 2e passage : réparer les champs désactivés par Google.
    for (const m of mutations) reparer(m.target)
  }).observe(doc.documentElement, {
    subtree: true,
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ['class', 'disabled', 'placeholder'],
  })

  // Signal officiel de Google en cas de refus de clé. La réparation reste à
  // l'observateur (il connaît le texte d'aide d'origine) ; ce qui lui aurait
  // échappé est rattrapé juste après.
  const precedent = win.gm_authFailure
  win.gm_authFailure = function () {
    neutraliserAutocomplete(maps())
    win.setTimeout(() => doc.querySelectorAll('.' + CLASSE_ERREUR).forEach(reparer), 0)
    if (typeof precedent === 'function') precedent()
  }
}
